// extracted by mini-css-extract-plugin
module.exports = {"body":"_67d79af","button":"_4ce5960"};